<template>
  <div class="auditorsReport financial-statements">
      <Header></Header>
      <div class="container"> 
          <h3 class="pageHeading" data-aos="fade-down" v-for="text in this.brc.mainheading" :key="text">{{text}}</h3>
          <h2 data-aos="fade-down" v-for="text in this.brc.subheading" :key="text">{{text}}</h2>
        <div class="inner-wrapper">
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.Opinion" :key="text" data-aos="fade-up">{{text}}</p>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading2" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.Basis" :key="text" data-aos="fade-up">{{text}}</p>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading3" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.matter" :key="text" data-aos="fade-up">{{text}}</p>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading4" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.Matters" :key="text" data-aos="fade-up">{{text}}</p>
            <div class="table-wrapper on-575">
                <div class="custom-table" data-aos="fade-down">
                    <div class="trow head bgGrey">
                        <div class="th">Key Audit Matter</div>
                        <div class="th">How Our Audit Addressed the Key Audit Matter</div>
                    </div>
                    <div class="trow">
                        <div>
                            <h6 class="skyblue">Revenue recognition</h6>
                            <p>The Group has recognized revenue from telecom services amounting to KD 1,626.885 million for the year ended 31 December 2020.</p>
                            <p>There is an inherent risk around telecom services revenue recognition because of the complexity of the related Information Technology (“IT”) environment, the processing of large volumes of data through a number of different IT systems and the combination of different products and prices.</p>
                            <p>Due to the complexities and dependencies on different IT systems in the revenue recognition process, we have considered this as a key audit matter.</p>
                            <p>The accounting policy for revenue recognition is set out in note 2.4.15 and the related disclosures are made in note 19 and note 25 to the consolidated financial statements.</p>
                        </div>
                        <div>
                            <h6 class="skyblue">Our audit procedures included:</h6>
                            <ul>
                                <li>An understanding of the significant revenue processes and identifying the relevant controls, IT systems, interfaces and reports;</li>
                                <li>An evaluation of the relevant IT systems, with the assistance of our internal IT specialists, and the design and implementation of internal controls related to revenue recognition. </li>
                                <li>Testing the operating effectiveness of controls over the recording of revenue transactions; authorization of rate changes and its input to the billing systems and the change control procedures in place around those systems.</li>
                                <li>Verifying key reconciliations performed by the Group’s Revenue Assurance team, including testing end to end reconciliation from business support systems to billing and rating systems to the general ledger, this testing includes validation of material journals processed between billing systems and general ledger. </li>
                                <li> Testing a sample of subscribers invoices back to the cash receipts.</li>
                                <li>Performing tests on the accuracy of subscribers bill generation on a sample basis.</li>
                            </ul>
                            <p>We also assessed the disclosures in the financial 
                            statements relating to this matter against the 
                            requirements of IFRSs.</p>
                        </div>
                    </div>
                    <div class="trow">
                        <div>
                            <h6 class="skyblue">Impairment of Goodwill</h6>
                            <p>As at 31 December 2020, goodwill is carried at KD 605.462 million which represents 12.3% of the total assets.</p>
                            <p>The impairment test of goodwill performed by management is significant to our audit because the assessment of the recoverable amount of goodwill under the value-in-use basis is complex and requires considerable judgment on the part of management. Estimates of future cash flows are based on management’s views of variables such as the growth in the telecommunications sector, economic growth, expected inflation rates and yield.</p>
                            <p>Therefore, we identified the impairment testing of goodwill as a key audit matter. </p>
                            <p>The Group’s policy on assessing impairment of goodwill is set out in note 2.4.8 and related disclosures are made in note 12 to the consolidated financial statements.</p>
                        </div>
                        <div>
                            <p>We evaluated the design and implementation of controls over the impairment assessment process.</p>
                            <p>With the support of our internal valuation experts, we benchmarked and challenged key assumptions forming the Group’s value-in-use calculation including the cash flow projections and discount rate.</p>
                            <p>We compared actual historical cash flows with previous forecasts and assessed differences, if any, were within an acceptable range. We assessed the overall reasonableness of the cash flow forecasts and compared the discount rate and growth rate to market data. </p>
                            <p>Additionally, we analyzed the sensitivities such as the impact on the valuation if the growth rate would be decreased, or the discount rate would be increased. </p>
                            <p>We also assessed the adequacy of the Group’s disclosures included in notes to the consolidated financial statements about those assumptions to which the outcome of the impairment test is more sensitive against the requirements of IFRSs.</p>
                        </div>
                    </div>
                </div>
            </div>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading5" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.information" :key="text" data-aos="fade-up">{{text}}</p>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading6" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.Responsibilities" :key="text" data-aos="fade-up">{{text}}</p>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading7" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.Auditor" :key="text" data-aos="fade-up">{{text}}</p>
            <ul>
                <li v-for="text in this.brc.Auditortext" :key="text" data-aos="fade-up">{{text}}</li>
            </ul>
            <p v-for="text in this.brc.text" :key="text" data-aos="fade-up">{{text}}</p>
            <h4 class="skyblue" data-aos="fade-up" v-for="text in this.brc.heading8" :key="text">{{text}}</h4>
            <p v-for="text in this.brc.text1" :key="text" data-aos="fade-up">{{text}}</p>
          </div>
      </div>
      <div class="bg-white detail">
          <div class="container" data-aos="fade-down">
              <div class="image" >
                  <img src="@/assets/images/svg/al-wazaan-signature.svg" alt="" class="img-fluid">
              </div>
              <h6>
                  Bader A. Al-Wazzan<br>  Licence No. 62A<br> Deloitte & Touche - Al-Wazzan & Co.
              </h6>
              <p >Kuwait <br>23 February 2021</p>
          </div>
      </div>
  </div>
</template>

<script>
import data from "@/components/financial/report.json";
const brc = [];
export default {
    components:{
        // sctionsScroll
    },
    data(){
        return{
            brc: data.brc
        }
    },
}
</script>
<style lang="scss">
    [data-page="auditors-report"]{
        .verticalLabel{
            color:#707070;
        }
    }
</style>
<style lang="scss" scoped>
/deep/{
    
   
    header{
        .menu {
            a{
                color:#000;
            }
            svg{
                fill:#000;
            }
        }
    }
    .custom-table{
        .trow{
            >div{
                width:50% !important;
                vertical-align: revert;
            }
        }
    }
}
.auditorsReport{
    background: #E8E8E8;
    overflow:hidden;
    padding:100px 0 0 0;
    .custom-table{
        p{
            font-size: 1.125rem;
            font-weight: 600;
            color: #707070 !important;
            line-height: 1.4;
            @media screen and (max-width:767px){
                font-size:rem(15px);
            }
        }
    }
    .detail{
        padding: rem(20px);
        padding-bottom:rem(40px);
        img{
            width:120px;
        }
        h6{
            margin-bottom:rem(20px);
            font-size:rem(20px);
        }
        p{
            margin-bottom:0;
            line-height: 1.2;
        }
    }
    h3{
        margin-bottom:rem(30px);
        @media screen and (max-width:767px){
            font-size:rem(25px);
        }
    }
    h4{
        font-size:rem(22px);
        font-weight:700;
        margin:rem(20px) 0;
         @media screen and (max-width:767px){
            font-size:rem(18px);
        }
    }
    p{
        font-size: rem(18px);
        font-weight: 600;
        color: #707070;
        line-height: 1.7;
        @media screen and (max-width:767px){
            font-size:rem(15px);
        }
    }
    ul{
        margin-left:rem(20px);
        margin-bottom:rem(20px);
        li{
            font-size: rem(18px);
            font-weight: 600;
            color: #707070;
            line-height: 1.7;
            @media screen and (max-width:767px){
                font-size:rem(15px);
            }
            &:not(:last-child){
                margin-bottom:7px;
            }
        }
    }
    /deep/{
        .custom-table {
            .trow {
                .th{
                    color:#fff;
                }
            }
        }
    }
}
</style>